{
  "metadata_main": {
    "title": "Jervice - Main",
    "description": "Your auto service"
  },
  "cart": {
    "title": "Cart",
    "confirm": "Place order",
    "empty": "The cart is empty",
    "added": "The service has been added to the cart",
    "or": "or",
    "continue_shopping": "Continue shopping"
  },
  "lang": {
    "en": "English",
    "pl": "Polish"
  },
  "global": {
    "order_button_label": "Order service",
    "view_button_label": "View",
    "privacy_policy": "Privacy Policy",
    "add_to_cart": "Add to cart",
    "in_cart": "In cart",
    "marquee": {
      "tuning_discount": "Tuning {percent}% discount"
    },
    "not_found": {
      "title": "Not found",
      "description": "You may have entered an incorrect address, or this page no longer exists.",
      "button_text": "Go to home"
    },
    "menu": {
      "home": "Home",
      "services": "Services",
      "contacts": "Contacts"
    }
  },
  "hero": {
    "title": "Discover a <1>New Standard</1> in Car Service!",
    "description": "JERVICE – a revolution in car maintenance. Fast service with real-time monitoring on your phone, for both combustion and electric vehicles.",
    "cars_updated_label": "Always at Your Service",
    "quality_services_label": "Quick-Service Bays",
    "banner_text_text": "Get high quality service in your city!"
  },
  "what_we_provide": {
    "title": "What do we offer?"
  },
  "mobile_app": {
    "title": "Discover our mobile app",
    "description": "book an appointment in just a few moments, track the current status of your service in real-time, and take advantage of special offers and discounts!"
  },
  "benefits": {
    "title": "Benefits",
    "quality": {
      "title": "Quality and Reliability",
      "description": "We use only high-quality certified materials and professional equipment for every service. We complete the tasks entrusted to us, regardless of their difficulty or deadlines."
    },
    "speed": {
      "title": "Speed",
      "description": "At Jervice, we value your time and comfort, which is why we focus on completing orders in the shortest possible time without compromising on quality."
    },
    "range": {
      "title": "Modern Solutions",
      "description": "We use an automated order system that ensures perfect service for every customer. We operate according to our offerings, where each service has a set completion time. If the service of your car is delayed due to our fault, you will receive a 10% discount for every additional 20 minutes of waiting."
    }
  },
  "services": {
    "title": "Our services",
    "all_services": "All services",
    "page_caption": "The price for the service (excluding material costs) depends on the specifications and type of vehicle.",
    "all_service_button_text": "Show all service",
    "back_to_services": "Back to list",
    "sub_service_title": "Subservice Name",
    "sub_service_caption": "Small description about it",
    "sub_service_start_from": "from {{qty}}",
    "service_order": "Order",
    "empty_subservices": "The list is empty",

    "tuning": {
      "title": "Tuning",
      "caption": "Enhancing the exterior appearance of vehicles.",
      "description": "We offer comprehensive solutions, including engine upgrades, suspension improvements, and high-quality equipment installations to make your vehicle more powerful and reliable."
    },
    "detailing": {
      "title": "Detailing",
      "caption": "Providing comprehensive detailing services to maintain the pristine condition of the car's interior and exterior.",
      "description": "Our detailing services provide comprehensive care for the appearance of your car – from professional cleaning and polishing to durable protective coatings that maintain its flawless look for a long time."
    },
    "car_wash": {
      "title": "Car Wash",
      "caption": "Comprehensive car washing services designed to keep your vehicle looking its best.",
      "description": "We offer thorough vehicle washing using paint-safe cleaning products and modern techniques that effectively remove dirt, leaving your car in perfect condition."
    },
    "sound_system": {
      "title": "Sound System",
      "caption": "Professional installation of new audio systems."
    },
    "battery_regeneration": {
      "title": "Battery Regeneration",
      "caption": "Providing battery regeneration services to extend their lifespan and optimize performance."
    },
    "electrical_installation": {
      "title": "Electrical Installation",
      "caption": "Providing qualified electrical installation services for both electric and conventional vehicles."
    },
    "sound_proofing": {
      "title": "Soundproofing",
      "caption": "Professional installation of new audio systems.",
      "description": "We offer professional soundproofing services for your car, significantly reducing interior noise. Our solutions help reduce road noise, making your journey quieter, more comfortable, and pleasant. We use high-quality soundproofing materials tailored to the specific needs of your vehicle."
    },
    "computer_diagnostic": {
      "title": "Computer Diagnostics",
      "caption": "Utilizing advanced computer diagnostics to identify and resolve vehicle issues."
    }
  },
  "contacts": {
    "title": "Find Us on the Map",
    "contacts_title": "Get in Touch with Us",
    "socials_title": "Follow Us on Social Media"
  },
  "privacy_policy": {
    "title": "Privacy Policy",
    "general": {
      "title": "General Provisions",
      "caption": "We respect your privacy and are committed to protecting your personal data. This Privacy Policy outlines how we collect, use, store, and protect your information."
    },
    "data_collection": {
      "title": "Data Collection",
      "caption": "We may collect the following information:",
      "list": {
        "item_0": "Your name and contact details (phone, email).",
        "item_1": "Information about your vehicle (make, model, license plate number).",
        "item_2": "Service history and inquiries."
      }
    },
    "personal_data": {
      "title": "Use of Personal Data",
      "caption": "The collected data is used to:",
      "list": {
        "item_0": "Schedule and manage service appointments.",
        "item_1": "Confirm and fulfill your orders.",
        "item_2": "Improve the quality of our services."
      }
    },
    "data_sharing": {
      "title": "Data Sharing",
      "caption": "We do not share your data with third parties unless required by law."
    },
    "data_retention": {
      "title": "Data Retention",
      "caption": "Your data is stored on secure servers. We take all measures to prevent unauthorized access or loss of your data."
    },
    "your_rights": {
      "title": "Your Rights",
      "caption": "You have the right to:",
      "list": {
        "item_0": "Request access to your personal data.",
        "item_1": "Request corrections or deletion of your data."
      }
    },
    "contact_us": {
      "title": "Contact Us",
      "caption": "If you have any questions, please contact us:",
      "email": "Email: {{email}}",
      "phone": "Phone: {{phone}}"
    },
    "back_button_text": "Back to Home page"
  },
  "order_service": {
    "info_caption": "Fill personal and car data",
    "info_title": "<wrapper>Auto</wrapper> Service Reservation",
    "full_name": "Full Name",
    "vehicle_brand": "Vehicle Brand",
    "phone_number": "Phone Number",
    "vehicle_model": "Vehicle Model",
    "email": "Email",
    "year": "Year",
    "license": "License",
    "company_order": "Company Order",
    "select_service": "Select Service",
    "service_caption": "Specify your choice",
    "service_title": "<wrapper>Select</wrapper> Service & Date",
    "time_slots": "Time slots",
    "service_type": "Type of service",
    "service": "Service",
    "add_service": "Add Service",
    "service_description": "If you’d like to schedule a different day for an additional service, please create a new order.",
    "checkout": "Proceed to checkout",
    "success": "Success!",
    "success_text": "Our operator will contact you within 1 hour.",
    "back_home": "Back Home",
    "select_country": "Select a country",
    "select_time": "Select time",
    "last_step": "Last step",
    "checkout_title": "Checkout",
    "service_list": "Service List",
    "total": "Total",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "no_services": "Service list is empty",
    "success_add": "Successfully added to the order!"
  },
  "cookies": {
    "title": "We use cookies",
    "description": "We use cookies and similar technologies to improve your experience on our website, analyze traffic, and personalize content. By clicking “Accept all”, you agree to the use of all cookies.",
    "settings": "Cookie settings",
    "necessary_title": "Necessary cookies (always active)",
    "necessary_description": "These cookies are required for the basic functionality of the website.",
    "analytics_title": "Analytics cookies",
    "analytics_description": "Help us understand how visitors interact with the website (Google Analytics).",
    "marketing_title": "Marketing cookies",
    "marketing_description": "Used to display relevant advertising and track campaign effectiveness.",
    "accept_all": "Accept all",
    "only_necessary": "Necessary only",
    "save_settings": "Save settings"
  },
  "order": {
    "form_title": "Order checkout",
    "services_title": "Services",
    "submit_button": "Confirm",
    "required_info": "Contact information",
    "optional_info": "Additional information",
    "choose_date": "Choose date and time",
    "time_slots": "Time slots",
    "not_available": "There are no available time\nslots for booking",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "success": "Success!",
    "success_text": "Our operator will contact you within 1 hour.",
    "total": "Total",
    "not_specified": "Not specified",
    "add_service": "Add Service",
    "checkout_title": "Checkout",
    "service_list": "Service List",
    "service_type": "Type of service",
    "select_service": "Select Service",
    "checkout": "Proceed to checkout",
    "available_time": "Available time",
    "pre_order_caption": "You are selecting a preliminary registration time.\nOur manager will contact you to confirm the actual time.",
    "invoice": {
      "title": "Order # {{order}}",
      "client": "Client",
      "car": "Car",
      "services": "Services"
    },
    "placeholders": {
      "name": "Full name",
      "phone": "Phone number",
      "email": "Email",
      "brand": "Car brand",
      "model": "Car model",
      "year": "Year of manufacture",
      "license": "License",
      "company_order": "Company Order"
    }
  }
}
